export const timelineOfIncidentsOptions = [
  {
    value: 'monthly',
    label: 'Dashboard::Monthly',
  },
  {
    value: 'weekly',
    label: 'Dashboard::Weekly',
  },
];
export const timelineOfIncidentsOptionsDefault = 'monthly';
